import { SxProps, Theme } from '@mui/material/styles';

const truncatedColumn = (width: string): SxProps<Theme> => ({
    width,
    minWidth: width,
    maxWidth: width,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
});

export const surveySelectionColumnSx = {
    include: truncatedColumn('calc(7ch + 16px)'),
    reference: truncatedColumn('calc(11.5ch + 16px)'),
    date: truncatedColumn('calc(10ch + 16px)'),
    dayOfWeek: truncatedColumn('calc(10.5ch + 16px)'),
    surveyType: truncatedColumn('calc(13.5ch + 16px)'),
    locationType: truncatedColumn('calc(21ch + 16px)'),
    town: truncatedColumn('calc(18ch + 16px)'),
    reason: { width: 'auto' } satisfies SxProps<Theme>,
};
